import { PhonesAttribute, DIYAttribute } from '@gumtree/shared/src/types/attributes';

type RefinePanelModelState = {
    featured_filter: boolean;
    q: string;
    search_location: string;
    search_category: string;
    urgent_filter: boolean;
    sort: string;
    search_scope: boolean;
    photos_filter: boolean;
    min_price?: string;
    max_price?: string;
    min_salary?: string;
    max_salary?: string;
    min_property_number_beds?: string;
    max_property_number_beds?: string;
};

export type FilterItem = {
    abundance: number;
    noSeoLink: boolean;
    abundanceOrZero: number;
    label: string;
    value: string;
    uri: string;
};

export type FilterData = {
    type:
        | 'enum'
        | 'boolean'
        | 'boolean-pets-health'
        | 'enum_range'
        | 'range_freeform'
        | 'searchable-enum';
    label?: string;
    parents: FilterItem[];
    values: FilterItem[];
    minValues: Pick<FilterItem, 'value' | 'label'>[];
    maxValues: Pick<FilterItem, 'value' | 'label'>[];
    minKey?: FilterKey;
    maxKey?: FilterKey;
};

export const ServerFilters = {
    vehicle_make: 'vehicle_make',
    search_location: 'search_location',
    vehicle_transmission: 'vehicle_transmission',
    vehicle_model: 'vehicle_model',
    vehicle_registration_year: 'vehicle_registration_year',
    photos_filter: 'photos_filter',
    search_scope: 'search_scope',
    vehicle_colour: 'vehicle_colour',
    featured_filter: 'featured_filter',
    vehicle_engine_size: 'vehicle_engine_size',
    vehicle_doors: 'vehicle_doors',
    search_category: 'search_category',
    urgent_filter: 'urgent_filter',
    vehicle_seats: 'vehicle_seats',
    vehicle_average_mpg: 'vehicle_average_mpg',
    seller_type: 'seller_type',
    vehicle_body_type: 'vehicle_body_type',
    vehicle_mileage: 'vehicle_mileage',
    vehicle_fuel_type: 'vehicle_fuel_type',
    property_couples: 'property_couples',
    suggested_searches: 'suggested_searches',
    pets_allowed: 'pets_allowed',
    all_bills_inc: 'all_bills_inc',
    council_tax_Inc: 'council_tax_Inc',
    job_course: 'job_course',
    dog_breed: 'dog_breed',
    cat_breed: 'cat_breed',
    pet_ready_to_leave_date: 'pet_ready_to_leave_date',
    property_room_type: 'property_room_type',
    deflead: 'deflead',
    neutered_or_spayed: 'neutered_or_spayed',
    vaccinated: 'vaccinated',
    microchipped: 'microchipped',
} as const;

type ServerFilterKeys =
    | typeof ServerFilters[keyof typeof ServerFilters]
    | PhonesAttribute['key']
    | DIYAttribute['key'];

export const ServerRangedFilters = {
    price: 'price',
    property_number_beds: 'property_number_beds',
    salary: 'salary',
    pet_dob: 'pet_dob',
} as const;

type ServerRangedFilterKeys = typeof ServerRangedFilters[keyof typeof ServerRangedFilters];

type ClientFilterKeys = 'sort' | 'q';

export type PrefixedServerRangedFilterKeys = `${'min_' | 'max_'}${ServerRangedFilterKeys}`;

export type Filter = {
    [K in
        | ServerFilterKeys
        | ClientFilterKeys
        | ServerRangedFilterKeys
        | PrefixedServerRangedFilterKeys]?: string | number | boolean;
};

type ValueOf<T> = T[keyof T];
export type FilterValue = ValueOf<Filter>;
export type FilterKey = keyof Filter;

export type RefinePanelModel = {
    filters: {
        [key in FilterKey]: {
            name: FilterKey;
            label: string;
            abundance: number;
            filterData: [FilterData];
            selectedValueLabel?: string;
        };
    };
    order: FilterKey[];
    adCount: number;
    state: RefinePanelModelState;
    refinementsCount: number;
};

export type FiltersDictionary = {
    [key in FilterKey]: FilterData;
};

export interface QaAnswer {
    answerId: string;
    answerText: string;
}

export interface QaItem {
    title: string;
    questionId: string;
    answers: QaAnswer[];
}

export interface PostAJobData {
    isVisible: boolean;
    qaList: QaItem[];
}
